import React, { Component } from "react";
import PropTypes from "prop-types";
import { all } from "awaity/esm";
import { Link } from "react-router";
import { Card, Row, Col } from "antd";
import { GaugeChart, makeWidthFlexible } from "@unifiedpatents/euclid-react";
const FlexibleGaugeChart = makeWidthFlexible(GaugeChart);
import { getCasesByClaimInstitutionOutcome, getCasesByClaimDecisionOutcome } from "../../../services/api-ptab";
import { sum, startCase } from "lodash";

class Rate extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["author", "panel"]).isRequired,
    apiCall: PropTypes.func.isRequired,
    nomKeys: PropTypes.arrayOf(PropTypes.string),
    denomKeys: PropTypes.arrayOf(PropTypes.string)
  };

  state = {
    nom: 0,
    denom: 1, // to avoid NaN
    nomAll: 0,
    denomAll: 1 // to avoid NaN
  };

  componentDidMount() {
    this._isMounted = true;
    this.getCounts();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { nom, denom, nomAll, denomAll } = this.state;
    const rateFormatter = v => `${(v * 100).toFixed(1)}%`;
    return (
      <div>
        <FlexibleGaugeChart value={nom / denom} domain={[0, 1]} textFormatter={rateFormatter} height={225} margin={{ top: 8, bottom: 32, left: 8, right: 8 }} />
        <small>PTAB Overall: {rateFormatter(nomAll / denomAll)}</small>
      </div>
    );
  }

  getCounts = () => {
    const { name, type, apiCall, nomKeys, denomKeys } = this.props;
    const judgeQueryKey = `judges.${type}`;
    all([apiCall({}), apiCall({ [judgeQueryKey]: name })])
      .then(([dataAll, data]) => {
        if (this._isMounted)
          this.setState({
            nom: sum(nomKeys.map(k => data[k])) || 0,
            denom: sum(denomKeys.map(k => data[k])) || 1,
            nomAll: sum(nomKeys.map(k => dataAll[k])) || 0,
            denomAll: sum(denomKeys.map(k => dataAll[k])) || 1
          });
      })
      .catch(() => {
        if (this._isMounted)
          this.setState({
            nom: 0,
            denom: 1, // to avoid NaN
            nomAll: 0,
            denomAll: 1 // to avoid NaN
          });
      });
  };
}

const JudgeRates = props => {
  const { name, type } = props;
  return (
    <Card title="Key Metrics" extra={<Link to={`/ptab/analytics/case-level/by-judge/${type}`}>{`View Top ${startCase(type)} Judges`}</Link>} style={props.style}>
      <Row>
        <Col xl={12} span={24} style={{ textAlign: "center" }}>
          <h3>Institution Rate</h3>
          <Rate
            name={name}
            type={type}
            apiCall={getCasesByClaimInstitutionOutcome}
            nomKeys={["All Claims Instituted", "Mixed Results"]}
            denomKeys={["All Claims Instituted", "Mixed Results", "No Claims Instituted"]}
          />
        </Col>
        <Col xl={12} span={24} style={{ textAlign: "center" }}>
          <h3>Self-Reversal Rate</h3>
          <Rate
            name={name}
            type={type}
            apiCall={getCasesByClaimDecisionOutcome}
            nomKeys={["All Claims Patentable"]}
            denomKeys={["All Claims Patentable", "Mixed Results", "All Claims Unpatentable"]}
          />
        </Col>
      </Row>
    </Card>
  );
};
JudgeRates.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["author", "panel"]).isRequired
};

export default JudgeRates;
